// extracted by mini-css-extract-plugin
module.exports = {"signinsignup":"login_signinsignup__1Dd2I"};